import { fetchValidStream } from './fetchValidStream';
export const ensureDownload = async (client, uuid, item) => {
    const { content, stream } = await fetchValidStream(client, item.id);
    content.asset.src = stream;
    return content;
};
//# sourceMappingURL=ensureDownload.web.js.map